const $ = jQuery.noConflict();
const header = $('.main-header');
const logo = $('.logo__item');
const logoTitle = $('.logo__title');
const logoWrapper = $('.main-header__logo');
const tabletChecker = window.matchMedia('screen and (max-width: 1024px)');
const mobileChecker = window.matchMedia('screen and (min-width: 768px)');

class Header {
    constructor(trigger = '.btn-hamburger', pbody = 'body', listParent = '.menu-item-has-children > a', alertMessage = '.alert-visible') {
        this.trigger = trigger;
        this.pbody = pbody;
        this.listParent = listParent;
        this.alertMessage = alertMessage;
    }
    init() {
        $(this.trigger).on('click', this.setNavState);
        this.currentMenuItem();
        this.stickyNav();
    }

    currentMenuItem() {
        if ($('.main-header__nav').find('.current_page_item').length > 0) {
            const that = $('.main-header__nav').find('.current_page_item');
            that.closest('.current-menu-parent').find('.arrow-menu-acc').trigger('click');
        }
    }

    stickyNav() {
        // set padding for page
        const headerHeight = header.outerHeight();
        let diff;
        if ($(this.alertMessage).length > 0) {
            diff = $(this.alertMessage).outerHeight();

            $('#page').css('marginTop', diff);

            header.css({
                position: 'relative',
            });
        } else {
            diff = 1;
            $('#page').css('paddingTop', headerHeight);
        }
        // make sticky on scroll, remove logo
        $(window).on('scroll', () => {
            if (($(window).scrollTop() > diff) && mobileChecker.matches) {
                logo.css({
                    opacity: 0,
                });
                // logo.fadeOut('400', () => {
                logoTitle.addClass('move-title');
                // });
                header.addClass('move');
            } else if (($(window).scrollTop() > diff) && !mobileChecker.matches) {
                header.addClass('move');
            } else {
                header.removeClass('move');
                logoTitle.removeClass('move-title');
                if (mobileChecker.matches) {
                    // logo.fadeIn('400').delay();
                    logo.css({
                        opacity: 1,
                    });
                }
            }
        });
    }

    setNavState(e) {
        e.preventDefault();
        const body = $('body');
        const overlay = $('.main-header__overlay');
        const search = $('.main-header__search .search-text');
        if ($(this).hasClass('open')) {
            Header.hideWrapper(this, body, search);
        } else {
            Header.showWrapper(this, body, overlay, search);
        }
    }

    static hideWrapper(el, body, search) {
        $(el).removeClass('open');
        body.removeClass('lock-scroll');
        $(el).next().removeClass('active');
        search.removeClass('expanded-menu');
        if (tabletChecker.matches) {
            logoWrapper.css({
                opacity: 1,
                'z-index': 10,
            });
        }
    }
    static showWrapper(el, body, overlay, search) {
        $(el).addClass('open');
        body.addClass('lock-scroll');
        overlay.addClass('visible');
        search.addClass('expanded-menu');
        $(el).next().addClass('active');
        if (tabletChecker.matches) {
            logoWrapper.css({
                opacity: 0,
                'z-index': 0,
            });
        }
    }
    // resized() {
    //     if (!$(this.trigger).is(':visible') && $(this.trigger).hasClass('open')) {
    //         Header.hideWrapper(this.trigger, $(this.pbody));
    //     }
    // }
    // hideOutsideClick(e) {
    //     if ($(this.trigger).length > 0 && $(this.trigger).hasClass('open')) {
    //         const container = $('.main-header');
    //         if (!container.is(e.target) && container.has(e.target).length === 0) {
    //             Header.hideWrapper(this.trigger, $(this.pbody));
    //         }
    //     }
    // }
}

export default Header;
